"use client";
import { IconAccordionButton } from "@repo/assets/images";
import cx from "classnames";
import { AnimatePresence, motion } from "framer-motion";
import { useTranslations } from "next-intl";
import { useState } from "react";

const Accordion = ({
  items,
  initialOpenIndices = [],
  itemContentClass,
  staticTitle,
}) => {
  const t = useTranslations("Common");
  // State to track which items are open
  const [openIndices, setOpenIndices] = useState(initialOpenIndices);

  const toggleItem = (index) => {
    setOpenIndices(
      (prev) =>
        prev.includes(index)
          ? prev.filter((i) => i !== index) // Remove index if already open
          : [...prev, index] // Add index if not already open
    );
  };
  return (
    <>
      {items?.map((item, index) => (
        <AccordionItem
          key={index}
          title={staticTitle ? t(item.title) : item.title}
          content={item.content}
          isOpen={openIndices.includes(index)}
          onToggle={() => toggleItem(index)}
          itemContentClass={itemContentClass}
        />
      ))}
    </>
  );
};

const AccordionItem = ({
  title,
  content,
  isOpen,
  onToggle,
  itemContentClass,
}) => {
  return (
    <div className="border-toolbar-filter-facetBorder border-b">
      <button
        onClick={onToggle}
        className="flex w-full items-center justify-between py-3 focus:outline-none"
      >
        <span className="text-toolbar-heading text-base font-medium md:text-lg">
          {title}
        </span>
        <span>
          <IconAccordionButton
            className={cx(
              "text-icon-color fill-current transition-all duration-300",
              {
                "-rotate-180": isOpen,
              }
            )}
          />
        </span>
      </button>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            key="accordion-content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { height: "auto", opacity: 1 },
              collapsed: { height: 0, opacity: 0 },
            }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <div
              className={`text-toolbar-filter-text py-1 text-sm ${itemContentClass}`}
            >
              {content}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Accordion;
